// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3yQad","col":"styles_col__2bCy4"};